import {Injectable} from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class EtatCompressionWebservicesService {

	compressionActivee = true;

	constructor() { }

	setCompressionActivee(compressionActivee: boolean) {
		this.compressionActivee = compressionActivee;
	}
}
